import React from 'react';

import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { getOpenGeocodingConfigDialogAction } from '~src/geocoding/actions/OpenGeocodingConfigDialogAction';
import { GeocodingTaskInfo } from '~src/geocoding/models/GeocodingTaskInfo';

export class GeocodingConfigNameDataGridCell extends React.Component<GeocodingTaskInfo> {
  private readonly toggleDialog = () => {
    getAppStore().dispatch(getOpenGeocodingConfigDialogAction(this.props));
  };

  render() {
    /* eslint-disable jsx-a11y/interactive-supports-focus */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/anchor-is-valid */
    return <>
      <a data-tb-test-id="data-grid-cell-text" onClick={this.toggleDialog} role="button">
        {this.props.geocodingConfigName}
      </a>
    </>;
  }
}
